var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4376 11.2538H11.8133C11.5028 11.2538 11.2508 11.5056 11.2508 11.816C11.2508 12.1263 11.545 12.3433 11.7851 12.5828L13.3481 14.1451C12.1744 15.1402 10.6603 15.7462 9 15.7462C5.65691 15.7462 2.88865 13.3136 2.35209 10.1244H0.0787353C0.633294 14.56 4.41168 17.9949 9 17.9949C11.2818 17.9949 13.3616 17.1427 14.946 15.7423L16.5574 17.3529C16.8605 17.6559 17.1271 18 17.4376 18C17.748 18 18 17.7481 18 17.4378V11.816C18 11.7479 18 11.2538 17.4376 11.2538ZM0.562412 6.74619H6.18671C6.49718 6.74619 6.74915 6.49433 6.74915 6.184C6.74915 5.87366 6.455 5.65667 6.21482 5.41719L4.65182 3.85487C5.82562 2.85981 7.33968 2.25378 8.99997 2.25378C12.3431 2.25378 15.1113 4.68636 15.6479 7.87561H17.9212C17.3667 3.43999 13.5883 0.00505661 9 0.00505661C6.71821 0.00505661 4.63835 0.85733 3.054 2.25775L1.44262 0.64707C1.13947 0.344055 0.872882 0 0.562412 0C0.251941 0 0 0.25186 0 0.562195V6.18403C0 6.25206 0 6.74619 0.562412 6.74619Z",
    fill: "#018DF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.30bf04d3.svg";
export { ForwardRef as ReactComponent };